/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LogOutAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LogOutAction({
  children,
  viewPath = "/App/RuntimeError/Error/LogOutAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="LogOutAction.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 block={true}
 marginTop={dtSpaceM}
 onClick={() => setFlowTo("/App/Auth/SignOut")}
 isSelected={flow.has("/App/Auth/SignOut")}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Sign Out"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}